import { render, staticRenderFns } from "./Summaries.vue?vue&type=template&id=73090132&"
import script from "./Summaries.vue?vue&type=script&lang=js&"
export * from "./Summaries.vue?vue&type=script&lang=js&"
import style0 from "./Summaries.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports